import * as R from 'ramda';

export type RouteType = {
  PATH: string;
  NAME: string;
  IS_PRIVATE: boolean;
  IS_UNAUTHENTICATED: boolean;
  IS_WITH_PLAYER: boolean;
  IS_WITH_HEADER: boolean;
  IS_WITH_FOOTER: boolean;
};

export const RoutesConfig = {
  PROFILE: {
    PATH: '/profile',
    NAME: 'Profile',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_PLAYER: true,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
  },
  ROOT: {
    PATH: '/',
    NAME: 'Root',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  DISCOVER: {
    PATH: '/discover',
    NAME: 'Discover',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  TECHNICAL: {
    PATH: '/technical',
    NAME: 'Technical',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  LEARNING_PATHS: {
    PATH: '/learning-paths',
    NAME: 'Learning Paths',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  LEARNING_PATHS_IN_PROGRESS: {
    PATH: '/learning-paths/in-progress',
    NAME: 'In Progress Learning Paths',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  LEARNING_PATHS_RECOMMENDED: {
    PATH: '/learning-paths/recommended',
    NAME: 'Recommended Learning Paths',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  LEARNING_PATHS_TOPICS: {
    PATH: '/learning-paths/topics',
    NAME: 'Learning Path Topics',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  LEARNING_PATH: {
    PATH: '/learning-path/:learningPathId',
    NAME: 'Learning Path',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  LOGIN: {
    PATH: '/login',
    NAME: 'Login',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  REGISTER: {
    PATH: '/register',
    NAME: 'Register',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  ACCEPT_INVITE: {
    PATH: '/accept-invite',
    NAME: 'Accept Invite',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  VERIFY_EMAIL: {
    PATH: '/verify-email',
    NAME: 'Verify Email',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  FORGOT_PASSWORD: {
    PATH: '/forgot-password',
    NAME: 'Forgot Password',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  RESET_PASSWORD: {
    PATH: '/reset-password',
    NAME: 'Reset Password',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  RECOVER_ACCOUNT: {
    PATH: '/recover-account',
    NAME: 'Recover Account',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: true,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  VALIDATE_INVITE: {
    PATH: '/plans/redeem/:inviteToken',
    NAME: 'Validate Invite',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  VALIDATE_OFFER: {
    PATH: '/offers/redeem/:offerId',
    NAME: 'Validate Offer',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  VALIDATE_FREE_TRIAL_OFFER: {
    PATH: '/free-trial/:offerId',
    NAME: 'Validate Free Trial',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  EMAIL_PREFERENCES: {
    PATH: '/email-preferences',
    NAME: 'Email Preferences',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  LIBRARY: {
    PATH: '/library',
    NAME: 'Library',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  MY_LUMIQ: {
    PATH: '/my-lumiq',
    NAME: 'My LumiQ',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  EPISODE: {
    PATH: '/episodes/:episodeId',
    NAME: 'Episode',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  EPISODE_ASSESSMENT: {
    PATH: '/episodes/:episodeId/assessment',
    NAME: 'Episode Assessment',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: true,
  },
  SEARCH: {
    PATH: '/search',
    NAME: 'Search',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  TRACKER: {
    PATH: '/tracker',
    NAME: 'Tracker',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  CPD_REQUIREMENTS: {
    PATH: '/cpd-requirements',
    NAME: 'CPD Requirements',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  PRICING: {
    PATH: '/pricing',
    NAME: 'Pricing',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  MY_OFFERS: {
    PATH: '/my-offers',
    NAME: 'Pricing',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  PURCHASE_SUCCESS: {
    PATH: '/purchase-success',
    NAME: 'Purchase Success',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  CPA_CANADA: {
    PATH: '/cpacanada',
    NAME: 'CPA Canada',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  CERTIFICATE_DOWNLOAD: {
    PATH: '/download-cert',
    NAME: 'Download Certificate',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  MEMBER_MANAGEMENT: {
    PATH: '/member-management',
    NAME: 'Members',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  REPORTING: {
    PATH: '/reporting',
    NAME: 'Reporting',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  ADMIN_CONTENT: {
    PATH: '/content-curation',
    NAME: 'Content Curation',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
  LOGOUT: {
    PATH: '/logout',
    NAME: 'Logout',
    IS_PRIVATE: false,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: false,
    IS_WITH_FOOTER: false,
    IS_WITH_PLAYER: false,
  },
  SHARE_WITH_A_FRIEND: {
    PATH: 'share-with-a-friend',
    NAME: 'Share With a Friend',
    IS_PRIVATE: true,
    IS_UNAUTHENTICATED: false,
    IS_WITH_HEADER: true,
    IS_WITH_FOOTER: true,
    IS_WITH_PLAYER: true,
  },
} satisfies Record<string, RouteType>;

export const Routes = R.mapObjIndexed(route => route.PATH, RoutesConfig);

export const PrivateRoutes = R.pipe(
  R.filter((route: RouteType) => route.IS_PRIVATE),
  R.mapObjIndexed((route: RouteType) => route.PATH),
)(RoutesConfig);

export const RoutesWithHeader = R.pipe(
  R.filter((route: RouteType) => route.IS_WITH_HEADER),
  R.mapObjIndexed((route: RouteType) => route.PATH),
)(RoutesConfig);

export const RoutesWithFooter = R.pipe(
  R.filter((route: RouteType) => route.IS_WITH_FOOTER),
  R.mapObjIndexed((route: RouteType) => route.PATH),
)(RoutesConfig);

export const RoutesWithPlayer = R.pipe(
  R.filter((route: RouteType) => route.IS_WITH_PLAYER),
  R.mapObjIndexed((route: RouteType) => route.PATH),
)(RoutesConfig);

export const UnauthenticatedRoutes = R.pipe(
  R.filter((route: RouteType) => route.IS_UNAUTHENTICATED),
  R.mapObjIndexed((route: RouteType) => route.PATH),
)(RoutesConfig);

export const NavRoutes = R.pick(
  ['DISCOVER', 'LEARNING_PATHS', 'LIBRARY', 'MY_LUMIQ', 'TRACKER'],
  RoutesConfig,
);

export const AdminRoutes = R.pick(
  ['MEMBER_MANAGEMENT', 'REPORTING', 'ADMIN_CONTENT'],
  RoutesConfig,
);
